import React from "react";
import {Box, Button, makeStyles, Typography} from "@material-ui/core";
import {useSnackbar} from "notistack";

const useStyles = makeStyles((theme) => ({
  confirmEmailContainer: {
    margin: "50px 0px",
  },
  confirmEmailText: {
    textAlign: "center",
    marginBottom: 20,
  },
  confirmEmailControls: {
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    }
  },
  confirmEmailBtn: {
    minWidth: 230,
    marginBottom: 10,
    color: theme.palette.primary.main,
    fontWeight: "bold",
    fontSize: 16,
  }
}));

const ConfirmEmail: React.FC = () => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const resendEmail = () => {
    // api_resendConfirmationEmail(user?.email)
    //     .then(() => {
    //       enqueueSnackbar("Please, check your email", {
    //         variant: "success",
    //         autoHideDuration: 4000
    //       });
    //     });
  };

  return (
      <Box width="100%" display="flex" justifyContent="center" flexDirection="column"
           className={classes.confirmEmailContainer}>
        <Typography className={classes.confirmEmailText} variant="h4">
          Please confirm your account
        </Typography>
        <Typography className={classes.confirmEmailText}>
          Please confirm your account in your email.
          Once confirmed, you can go through onboarding.
        </Typography>
        <Typography className={classes.confirmEmailText} variant="h4">
          Having issues?
        </Typography>
        <Box display="flex" justifyContent="center" className={classes.confirmEmailControls}>
          <Button
              variant="outlined"
              color="secondary"
              className={classes.confirmEmailBtn}
              onClick={resendEmail}
          >
            Resend confirmation email
          </Button>
        </Box>
      </Box>
  );
};
export default ConfirmEmail;
